import * as TYPES from './mutations-types'

export default {
  [TYPES.STORE_PHOTO] (state, data) {
    state.pic = data
  }
}



// WEBPACK FOOTER //
// ./src/store/module/photo/mutations.js